import PropTypes from 'prop-types';
import { IonCol, IonRow } from '@ionic/react';
import ProfileFieldInputMob from './ProfileFieldInputMob';
import { getProfileFieldRowState } from './profileFieldGridHelpers';

/**
 * Ionic profile fields for product/package purchase modals (keyed by profile_field_id).
 */
const ProductProfileFieldsGridMob = ({
  profileFields,
  formValues,
  formSubmitted,
  onChange,
  fieldErrors,
}) => {
  if (!profileFields?.length) {
    return null;
  }

  return profileFields.map((group, groupIndex) =>
    group?.profile_fields?.map((field, fieldIndex) => {
      const fieldId = field.profile_field_id;
      const { displayValue, helperText, hasError } = getProfileFieldRowState(
        field,
        formValues[fieldId],
        formSubmitted,
        fieldErrors,
        fieldId,
      );

      return (
        <IonRow key={`${groupIndex}-${fieldId ?? fieldIndex}`}>
          <IonCol size='12'>
            <ProfileFieldInputMob
              field={field}
              value={displayValue}
              onChange={onChange}
              error={hasError}
              helperText={helperText}
            />
          </IonCol>
        </IonRow>
      );
    }),
  );
};

ProductProfileFieldsGridMob.propTypes = {
  profileFields: PropTypes.array,
  formValues: PropTypes.object,
  formSubmitted: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object,
};

export default ProductProfileFieldsGridMob;
